import { render, staticRenderFns } from "./mm-toast.vue?vue&type=template&id=56dc6ea0&"
import script from "./mm-toast.vue?vue&type=script&lang=js&"
export * from "./mm-toast.vue?vue&type=script&lang=js&"
import style0 from "./mm-toast.vue?vue&type=style&index=0&id=56dc6ea0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports